import { useEffect } from "react";
import { PrimaryFormRadioGroup } from "react-common-ui-library";
import { useFormContext, useWatch } from "react-hook-form";
import { useSelector } from "react-redux";
import { EMPTY, NO_VALUE, YES_VALUE } from "../../../Constants/CommonConstants";
import {
  PROF_LICENSE_NO,
  PROF_LICENSE_NO_RADIO_FIELD,
  PROFESSIOANL_LICENSE_NUMBER_RADIO_LABEL,
  PROFESSIONAL_LICENSE_NUMBER_RADIO_FIELD_REQUIRED_ERROR,
} from "../../../Constants/ProviderAndCertifierAccountCreationConstants";
import { manageReferenceDataSelector } from "../../../Selectors/ReferenceDataSelector";
import { ProfessionalLicenseNumber } from "./ProfessionalLicenseNumber";

/**
 * @description Displays the Professional Lisence Number radio input field to the user
 */
export const ProfLicenseNumberForm = () => {
  const { commonYesNo } = useSelector((state) =>
    manageReferenceDataSelector(state)
  );

  const hasProfLicenseNoValue = useWatch({
    name: PROF_LICENSE_NO_RADIO_FIELD,
  });

  const hasProfLicenseNo = hasProfLicenseNoValue === YES_VALUE;

  const { resetField } = useFormContext();

  useEffect(() => {
    if (hasProfLicenseNoValue === NO_VALUE) {
      resetField(PROF_LICENSE_NO, { defaultValue: EMPTY });
    }
  }, [resetField, hasProfLicenseNoValue]);

  return (
    <>
      <PrimaryFormRadioGroup
        formProps={{
          name: PROF_LICENSE_NO_RADIO_FIELD,
          rules: {
            required: PROFESSIONAL_LICENSE_NUMBER_RADIO_FIELD_REQUIRED_ERROR,
          },
        }}
        labelProps={{
          labelText: PROFESSIOANL_LICENSE_NUMBER_RADIO_LABEL,
          required: true,
        }}
        fieldProps={{
          radioOptions: commonYesNo,
        }}
      />

      {hasProfLicenseNo ? (
        <ProfessionalLicenseNumber hasProfLicenseNo={hasProfLicenseNo} />
      ) : null}
    </>
  );
};
